<template>
  <v-card style="width: 100%">
    <v-card-text class="pa-6">
      <div>
        <LineChart style="width: 100%; position: relative" :chartdata="chartData" :options="chartOptions" />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import LineChart from '@/components/basic/chart/LineChart.vue'
import { BoardingClassSession } from '@/plugins/api'
export default {
  components: { LineChart },
  props: {
    filters: Object,
    currClass: Object,
  },
  data() {
    return {
      chartData: null,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                min: 0,
                stepSize: 10,
                reverse: false,
                beginAtZero: true,
              },
            },
          ],
        },
      },
      loaded: false,
    }
  },
  methods: {
    async searchboardingClassSessionClass() {
      this.$loading.active = true

      try {
        const data = await BoardingClassSession.getBoardingClassChartData({ ...this.filters })
        this.processData(data)
      } catch (error) {
        this.$alert.error('Không lấy được danh sách chuyên cần lớp bán trú')
        console.error(error)
      }
      this.$loading.active = false
    },
    processData(data) {
      const labels = data.map(item => item.date)
      const absentCount = data.map(item => item.absentCount)
      const excusedAbsentCount = data.map(item => item.excusedAbsentCount)
      const unexcusedAbsentCount = data.map(item => item.unexcusedAbsentCount)

      this.chartData = {
        labels: labels,
        datasets: [
          {
            label: 'Vắng mặt',
            backgroundColor: '#FF9800',
            borderColor: '#FF9800',
            data: absentCount,
            fill: false,
            lineTension: 0,
          },
          {
            label: 'Có phép',
            borderColor: '#c9c9c9',
            backgroundColor: '#c9c9c9',
            data: excusedAbsentCount,
            fill: false,
            lineTension: 0,
          },
          {
            label: 'Không phép',
            backgroundColor: '#FBC02D',
            borderColor: '#FBC02D',
            data: unexcusedAbsentCount,
            fill: false,
            lineTension: 0,
          },
        ],
      }
    },
  },
}
</script>

<style scoped></style>
